/** Only same-origin app paths are allowed as post-login targets (no open redirect). */
export const safeReturnPath = (from: unknown): string => {
  if (typeof from !== 'string' || !from.startsWith('/') || from.startsWith('//') || from.startsWith('/\\')) {
    return '/';
  }
  return from.startsWith('/login') ? '/' : from;
};
